<template>
  <div class="myDialog" @click.self="closeLoginForm">
    <div class="login">
      <!-- 修改密码 -->
      <div class="loginCenter" v-if="$store.getters.editPwd == 1">
        <div class="title">修改密码</div>
        <el-form class="demo-form-inline" label-width="30px">
          <el-form-item label>
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="loginForm.oldPsw"
              placeholder="请输入旧密码"
              type="password"
              show-password
              maxlength="8"
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[/\s]/g ,'')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="loginForm.newPsw"
              placeholder="请输入新密码"
              type="password"
              show-password
              maxlength="8"
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[/\s]/g ,'')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="loginForm.newPswAgain"
              placeholder="请确认密码"
              type="password"
              show-password
              maxlength="8"
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[/\s]/g ,'')"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="onSubmit" :disabled="disabledBtn"
          >修改密码</el-button
        >
      </div>
      <!-- 注册 -->
      <div class="loginCenter" v-if="$store.getters.editPwd == 2">
        <div class="close-login-center">
          <img
            class="login-center-img"
            src="@/assets/image/index/close.png"
            alt
            @click="closeLoginForm"
          />
        </div>
        <div class="title">修改信息</div>
        <el-form class="demo-form-inline" label-width="60px">
          <el-form-item label>
            <template slot="label">
              <i class="el-icon-user"></i>
            </template>
            <el-input
              v-model="userInfo.nickName"
              placeholder="请输入用户昵称"
            ></el-input>
          </el-form-item>
          <el-form-item label v-if="userDeptInfo">
            <template slot="label">
              <i class="el-icon-user"></i>
            </template>
            <el-input
              v-model="userDeptInfo.deptName"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label v-if="userDeptInfo">
            <template slot="label">
              <i class="el-icon-lock"></i>
            </template>
            <el-input
              v-model="userDeptInfo.organizationCode"
              placeholder="请输入组织机构代码"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="userDeptInfo">
            <template slot="label">
              <i class="el-icon-location-outline"></i>
            </template>
            <el-cascader
              style="width: 100%"
              :options="options"
              v-model="selectedOptions"
              @change="addressChoose"
              placeholder="请选择地址"
            ></el-cascader>
          </el-form-item>

          <el-form-item v-if="userDeptInfo" style="position: relative">
            <template slot="label">
              <i class="el-icon-picture-outline"></i>
            </template>
            <el-input :placeholder="placeholder1" type="text" readonly>
              <template slot="suffix">
                <el-upload
                  class="upload-demo"
                  :action="action"
                  accept=".jpg, .png"
                  list-type="picture-card"
                  multiple
                  :limit="1"
                  :file-list="fileList1"
                  :before-upload="beforeUpload1"
                  :on-preview="handlePictureCardPreview1"
                  :on-success="handleSuccess1"
                  :on-remove="handleRemove1"
                >
                  <div
                    style="color: #2579bf"
                    class="upLoad"
                    v-if="fileList1.length < 1"
                  >
                    上传+
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" style="z-index: 999">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item style="position: relative">
            <template slot="label">
              <i class="el-icon-picture-outline"></i>
            </template>
            <el-input :placeholder="placeholder" type="text" readonly>
              <template slot="suffix">
                <el-upload
                  class="upload-demo"
                  :action="action"
                  accept=".jpg, .png"
                  list-type="picture-card"
                  multiple
                  :limit="1"
                  :file-list="fileList"
                  :before-upload="beforeUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-success="handleSuccess"
                  :on-remove="handleRemove"
                >
                  <div
                    style="color: #2579bf"
                    v-if="fileList.length < 1"
                    class="upLoad"
                  >
                    上传+
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" style="z-index: 999">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="register" :disabled="disabledBtn"
          >确 定</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { JSEncrypt } from "@/assets/js/jsencrypt.min.js";
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
export default {
  name: "dialogLogin",
  props: {},
  data() {
    return {
      fileList: [],
      fileList1: [],
      loginForm: {
        oldPsw: "",
        newPsw: "",
      },
      userInfo: {}, // 用户信息
      userDeptInfo: {}, //企业用户信息
      dialogImageUrl: "",
      dialogVisible: false,
      placeholder: "请上传用户头像",
      placeholder1: "请上传营业执照",
      publcKey: "", //公钥
      action: this.$store.state.axiosUrl + "/api/file/pb/upload",
      disabledBtn: false,
      options: regionData,
      selectedOptions: [],
    };
  },
  mounted() {
    if (sessionStorage.getItem("publcKey")) {
      this.publcKey = sessionStorage.getItem("publcKey");
    }
    this.userInfo = this.$store.getters.userInfo;
    this.userDeptInfo = this.$store.getters.userDeptInfo;
    console.log(this.userDeptInfo);
    if (this.userInfo.avatar) {
      this.fileList.push({
        url: this.$store.getters.imgUrl + this.userInfo.avatar,
      });
      this.placeholder = "";
    }
    if (this.userDeptInfo.businessLicense) {
      this.fileList1.push({
        url: this.$store.getters.imgUrl + this.userDeptInfo.businessLicense,
      });
      this.placeholder1 = "";
    }
    let a = TextToCode[this.userDeptInfo.province].code;
    let b = TextToCode[this.userDeptInfo.province][this.userDeptInfo.city].code;
    let c =
      TextToCode[this.userDeptInfo.province][this.userDeptInfo.city][
        this.userDeptInfo.district
      ].code;
    this.selectedOptions = [a, b, c];
    console.log(this.selectedOptions);
  },
  methods: {
    //企业营业执照
    // 上传之前
    beforeUpload1(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);

      const whiteList = ["jpg", "png"];

      if (whiteList.indexOf(fileSuffix) === -1) {
        this.message({
          message: "上传文件只能是 jpg,png格式",
          type: "warning",
        });
        return false;
      }
    },
    // 上传放大
    handlePictureCardPreview1(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传成功之后
    handleSuccess1(file) {
      this.placeholder1 = "";
      this.userDeptInfo.businessLicense = file.url;
      this.userDeptInfo.businessLicenseThumbnail = file.smUrl;
    },
    //删除文件
    handleRemove1() {
      this.placeholder1 = "请上传营业执照";
      this.userDeptInfo.businessLicense = "";
      this.userDeptInfo.businessLicenseThumbnail = "";
      this.fileList1 = [];
    },
    onSubmit() {
      // 修改密码
      console.log(this.loginForm.oldPsw);
     let pwdReg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8}$/;
      if (!this.loginForm.oldPsw) {
        this.$message.error("旧密码不能为空");
      } else if (!this.loginForm.newPsw) {
        this.$message.error("新密码不能为空");
      }else if (!this.loginForm.newPswAgain) {
        this.$message.error("确认密码不能为空");
      }
      else if (
        this.loginForm.newPsw.length != 8 ||
        this.loginForm.newPswAgain.length != 8
      ) {
        this.$message.error("密码必须等于8位");
      } else if (
        this.loginForm.newPsw.length == 8 &&
        !pwdReg.test(this.loginForm.newPsw)
      ) {
        this.$message.error(
          "密码必须包含⼤、小写字母、数字、特殊字符（四种⾥⾄少三种）"
        );
      } else if (this.loginForm.newPswAgain != this.loginForm.newPsw) {
        this.$message.error("两次新密码输入不一致，请重新输入");
      } else {
        this.disabledBtn = true;
        var encrypt = new JSEncrypt();
        encrypt.setPublicKey(this.publcKey);
        console.log(this.publcKey);
        console.log(this.loginForm);
        let formData = new FormData();
        formData.append("oldPsw", this.loginForm.oldPsw);
        formData.append("newPsw", this.loginForm.newPsw);
        console.log(formData);
        this.ajaxUtil({
          method: "put",
          url: this.$store.state.axiosUrl + "/api/user/psw",
          data: formData,
        }).then((res) => {
          this.disabledBtn = false;
          this.$message.success("修改成功，请重新登录");
          this.$store.dispatch("getToken", "");
          this.$store.commit("changeDialog", true);
          this.$store.commit("changeToggle", 1);
          this.$store.dispatch("getEditPwd", 0);
        });
      }
    },
    addressChoose(value) {
      this.userDeptInfo.province = CodeToText[value[0]];
      this.userDeptInfo.city = CodeToText[value[1]];
      this.userDeptInfo.district = CodeToText[value[2]];
      console.log(this.userDeptInfo);
    },
    beforeUpload(file) {
      // 上传之前
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["jpg", "png"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.message({
          message: "上传文件只能是 jpg,png格式",
          type: "warning",
        });
        return false;
      }
    },
    handlePictureCardPreview(file) {
      // 上传放大
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(file) {
      // 上传成功之后
      this.placeholder = "";
      this.userInfo.avatar = file.url;
    },
    handleRemove() {
      // 删除文件
      this.placeholder = "请上传用户头像";
      this.userInfo.avatar = "";
      this.fileList = [];
    },
    closeLoginForm() {
      if (sessionStorage.getItem("userInfo")) {
        this.$store.commit(
          "userInfo",
          JSON.parse(sessionStorage.getItem("userInfo"))
        );
      }
      this.userInfo = this.$store.getters.userInfo;
      this.$store.commit("editPwd", 0);
    },
    register() {
      // 修改头像+昵称
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("avatar", this.userInfo.avatar);
      formData.append("nickName", this.userInfo.nickName);
      this.ajaxUtil({
        method: "post",
        url: this.$store.state.axiosUrl + "/api/user/info",
        data: formData,
      }).then((res) => {
        this.disabledBtn = false;
        sessionStorage.setItem("userInfo", res.data);
        this.$store.commit("userInfo", res.data);
        this.$store.dispatch("getEditPwd", 0);
        if (!this.userDeptInfo) {
          this.$message.success("修改成功");
        }
      });
      if (this.userDeptInfo) {
        let formData = new FormData();
        formData.append("deptName", this.userDeptInfo.deptName);
        formData.append("province", this.userDeptInfo.province);
        formData.append("city", this.userDeptInfo.city);
        formData.append("organizationCode", this.userDeptInfo.organizationCode);
        formData.append("businessLicense", this.userDeptInfo.businessLicense);
        formData.append(
          "businessLicenseThumbnail",
          this.userDeptInfo.businessLicenseThumbnail
        );
        this.ajaxUtil({
          method: "post",
          url: this.$store.state.axiosUrl + "/api/dept/updateUserDeptInfo",
          data: this.userDeptInfo,
        }).then((res) => {
          sessionStorage.setItem("userDeptInfo", this.userDeptInfo);
          this.$store.commit("userDeptInfo", this.userDeptInfo);
          this.$message.success("修改成功");
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.myDialog {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 111;
  .login {
    width: 4.8em;
    background-color: rgba(#24a0ee, 0.2);
    border-radius: 10px;
    padding: 10px;
    .loginCenter {
      background-color: #fff;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 20px;
      .title {
        font-size: 25px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #2579bf;
      }
      //
      .demo-form-inline:last-child {
        border: none;
      }
      .demo-form-inline {
        margin-top: 50px;
        width: 80%;
        /deep/.el-form-item {
          border-bottom: 1px solid #cccccc;
          i {
            font-size: 18px;
            color: #ccc;
          }
        }
        /deep/.el-input__inner {
          border: none;
          border-radius: 0;

          width: 100%;
          padding-left: 0px;
          color: #333;
        }
        /deep/.el-select {
          width: 100%;
        }
      }
      .loginFooter {
        display: flex;
        width: 70%;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #215799;
        margin-top: 20px;
        span {
          cursor: pointer;
        }
      }
      .close-login-center {
        width: 100%;
        height: 30px;
        text-align: right;
        position: relative;
        font-size: 10px;
        .login-center-img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
.el-button--primary {
  width: 80%;
  background-color: #2579bf;
  margin-top: 30px;
  padding: 15px;
  font-size: 18px;
}
.gotoLogin {
  font-size: 16px;
  color: #215799;
  margin-top: 20px;
}
// 上传样式
/deep/.el-upload.el-upload--picture-card {
  background-color: rgba(0, 0, 0, 0) !important;
  border: none;
  height: 10px;
  width: 40px;
  position: absolute;
  right: 0px;
  bottom: 80px;
}
/deep/.el-upload-list__item {
  width: 4em;
  height: 4em;
  position: relative;
  right: 14em;
  bottom: 1.2em;
}
/deep/.el-upload-list__item.is-success {
  width: 60px;
  height: 60px;
  position: relative;
  right: 14em;
  bottom: 1.3em;
}
/deep/.el-dialog__body {
  img {
    width: 85% !important;
  }
}
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
/deep/.el-dialog__body {
  width: 80%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.upLoad {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/editPwd.vue